import React from "react";
import type { DispositionOption } from "./types";

type Props = {
  options: DispositionOption[];
  activeDisposition: string;
  onDispositionChange: (disposition: string) => void;
};

const hasGatewayBarrier = (option: DispositionOption): boolean =>
  (option.criteria ?? []).some((c) => c.status === "Gateway Barrier");

const DispositionOptionTabs: React.FC<Props> = ({
  options,
  activeDisposition,
  onDispositionChange,
}) => {
  if (options.length === 0) return null;

  return (
    <div className="flex max-w-full flex-wrap gap-2">
      {options.map((option) => {
        const isActive = option.disposition === activeDisposition;
        const barrier = hasGatewayBarrier(option);

        return (
          <button
            key={option.disposition}
            type="button"
            onClick={() => onDispositionChange(option.disposition)}
            className={`inline-flex w-[17.5rem] shrink-0 items-center justify-between gap-2 rounded-md border-2 px-3 py-1.5 font-semibold transition-colors ${
              isActive
                ? "border-indigo-600 bg-indigo-600 text-white hover:bg-indigo-700"
                : "border-gray-300 bg-white text-gray-900 hover:border-gray-400 hover:bg-gray-50"
            }`}
          >
            <span className="min-w-0 flex-1 text-left text-sm whitespace-nowrap">
              {option.disposition}
            </span>
            <span
              className={`shrink-0 rounded px-1.5 py-0.5 text-[11px] font-bold tabular-nums text-white ${
                barrier ? "bg-orange-500" : "bg-emerald-600"
              }`}
            >
              {option.probability}%
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DispositionOptionTabs;
